import { Component, inject, OnInit } from '@angular/core';
import { AppDataService, FuncService } from '../../services';
import { DashboardListPart } from './dashboard-list-part';
import { HomeToolbarPart } from './home-toolbar-part';


@Component({
	selector: 'home-page',
	imports: [DashboardListPart, HomeToolbarPart],
	templateUrl: './home.page.html',
	styleUrl: 'home.page.scss',
})
export class HomePage implements OnInit {

	public appData = inject(AppDataService);
	private func = inject(FuncService);

	async ngOnInit() {
		this.appData.setLatest(await this.func.appData.get());
	}

}
